var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Row', {
    staticClass: "addUser",
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Tabs', {
    attrs: {
      "animated": false,
      "name": "tab1-2"
    }
  }, [_c('TabPane', {
    attrs: {
      "tab": "tab1-2",
      "label": $t("gio3m94", "组织架构"),
      "name": "org"
    }
  }, [_c('STree', _vm._b({
    ref: "Tree",
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "changePush": _vm.onSelectChangeTree
    }
  }, 'STree', _vm.$attrs, false))], 1), _vm.tagVisible ? _c('TabPane', {
    attrs: {
      "tab": "tab1-2",
      "label": $t("idef2", "标签"),
      "name": "tag"
    }
  }, [_c('div', {
    staticClass: "content-col"
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l(_vm.tagList, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item",
      on: {
        "click": function ($event) {
          return _vm.onSelectChangeTag(item);
        }
      }
    }, [_c('span', [_c('Icon', {
      staticClass: "icon",
      attrs: {
        "type": _vm.identityIcon['TAG']
      }
    }), _c('span', [_vm._v(_vm._s(item.tagName))]), _c('Icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.isCheck,
        expression: "item.isCheck"
      }],
      staticClass: "check_icon",
      attrs: {
        "color": "#3D7FFF",
        "type": "md-checkmark"
      }
    })], 1)]);
  }), 0)])]) : _vm._e()], 1)], 1), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.checkedTitle))]), _c('OrgUserTagSelectList', {
    attrs: {
      "list": _vm.checkTree
    },
    on: {
      "remove": _vm.onDelete
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };